import { render, staticRenderFns } from "./VideoContentFeedManagement.vue?vue&type=template&id=8665673c&scoped=true"
import script from "./VideoContentFeedManagement.vue?vue&type=script&lang=js"
export * from "./VideoContentFeedManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8665673c",
  null
  
)

export default component.exports